
import { useState } from "react";

export function useLensFocus() {
  const [lensType, setLensType] = useState<string | undefined>(undefined);
  const [shouldShowLensFocus, setShouldShowLensFocus] = useState(false);
  
  const selectLensFocus = (lensTypeSelected: string) => {
    console.log("Lens type selected:", lensTypeSelected);
    setLensType(lensTypeSelected);
    setShouldShowLensFocus(false);
  };
  
  return {
    lensType,
    setLensType,
    shouldShowLensFocus,
    setShouldShowLensFocus,
    selectLensFocus
  };
}
